// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.settlement-btn {
  background-color: #343a40; /* Bootstrap dark, slightly softened */
  color: #fff;
  font-size: 0.875rem;
  padding: 0.4rem 0.75rem;
  border-radius: 0.375rem;
  box-shadow: none;
  transition: background-color 0.2s ease;
}

.settlement-btn:hover {
  background-color: #23272b; /* Slightly darker on hover */
  color: #fff;
}

.settlement-btn:focus {
  outline: none;
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.4); /* subtle focus */
}

`, "",{"version":3,"sources":["webpack://./src/containers/Settlements/Settlements.css"],"names":[],"mappings":";AACA;EACE,yBAAyB,EAAE,sCAAsC;EACjE,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB,EAAE,6BAA6B;EACxD,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8CAA8C,EAAE,iBAAiB;AACnE","sourcesContent":["\n.settlement-btn {\n  background-color: #343a40; /* Bootstrap dark, slightly softened */\n  color: #fff;\n  font-size: 0.875rem;\n  padding: 0.4rem 0.75rem;\n  border-radius: 0.375rem;\n  box-shadow: none;\n  transition: background-color 0.2s ease;\n}\n\n.settlement-btn:hover {\n  background-color: #23272b; /* Slightly darker on hover */\n  color: #fff;\n}\n\n.settlement-btn:focus {\n  outline: none;\n  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.4); /* subtle focus */\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
